import { render } from "./ContextbarReports.vue?vue&type=template&id=c506c016&scoped=true"
import script from "./ContextbarReports.vue?vue&type=script&lang=js"
export * from "./ContextbarReports.vue?vue&type=script&lang=js"

import "./ContextbarReports.vue?vue&type=style&index=0&id=c506c016&lang=css"
import "./ContextbarReports.vue?vue&type=style&index=1&id=c506c016&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c506c016"]])

export default __exports__